import { Fields } from '@measured/puck';
import WidthAndHeight, {
  WidthAndHeightField,
  WidthAndHeightSubProps,
} from './widthAndHeight';

// Define the types for ImageProps and Fields
export interface ImageProps {
  image: WidthAndHeightSubProps;
}

export const imageProps = (type: string[], justifyContent?: boolean) => {
  const imageField: WidthAndHeightField = {
    height: {
      label: 'Height',
      type: 'input',
    },
    maxWidth: {
      label: 'Max Width',
      type: 'input',
    },
  };

  if (justifyContent) {
    imageField.justifyContent = {
      type: 'select',
      label: 'Justify-Content',
      options: [
        { label: 'start', value: 'justify-start' },
        { label: 'center', value: 'justify-center' },
        { label: 'end', value: 'justify-end' },
      ],
    };
  }

  if (type.length > 0) {
    type.forEach(key => {
      delete imageField[key as keyof WidthAndHeightField];
    });
  }

  return {
    image: {
      type: 'custom',
      label: 'Image',
      render: ({ value, onChange }) => {
        return (
          <WidthAndHeight
            value={value}
            onChange={onChange}
            WidthAndHeightField={imageField}
            title="Customize Image"
          />
        );
      },
      defaultItemProps: {
        borderRadius: 'rounded-md',
        border: 'border-none',
        height: 'h-[200px]',
        maxWidth: '!max-w-[200px]',
        JustifyContentField: 'justify-start',
      },
    },
  } as Fields<ImageProps>;
};
